
export default function validate(values, props) {
  const { t } = props;
    let errors = {};
    if (!values.toemail) {
        errors.toemail = t('Common_ToEmailRequired');
      } else if (!/\S+@\S+\.\S+/.test(values.toemail)) {
        errors.toemail = t('Common_ToEmailInvalid');
      }
    if (!values.fromemail) {
      errors.fromemail = t('Common_FromEmailRequired');
    } else if (!/\S+@\S+\.\S+/.test(values.fromemail)) {
      errors.fromemail = t('Common_FromEmailInvalid');
    }
    if (!values.subject) {
      errors.subject = t('Common_SubjectRequired');
    } 
    /*if (!values.note) {
      errors.note = 'Note is required';
    } else if (values.note.length < 10) {
      errors.note = 'Note must be 10 or more characters';
    }
    if (!values.subject) {
        errors.subject = 'subject is required';
      } else if (values.subject.length < 10) {
        errors.note = 'subject must be 10 or more characters';
      }      */
    return errors;
  }

  